var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindingSleep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sleep"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.52 11.46C21.52 16.08 17.78 19.82 13.16 19.82C12.75 19.82 12.35 19.79 11.96 19.72C12.12 19.45 12.19 19.13 12.19 18.8C12.19 17.64 11.26 16.71 10.1 16.71C9.85 16.71 9.59 16.77 9.35 16.85C9.36 16.75 9.39 16.65 9.39 16.55C9.39 15.14 8.23 13.99 6.82 13.99C6.28 13.99 5.77 14.16 5.37 14.46C5 13.53 4.8 12.51 4.8 11.45C4.8 6.83 8.54 3.09 13.16 3.09C13.65 3.09 14.13 3.13 14.61 3.22C12.07 3.79 10.15 6.06 10.15 8.77C10.15 11.91 12.71 14.46 15.84 14.46C18.55 14.46 20.83 12.54 21.39 10C21.47 10.48 21.52 10.96 21.52 11.45V11.46Z",
    fill: "#0D70DC",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.18 18.81C12.18 19.13 12.11 19.46 11.95 19.73C11.65 20.35 11.06 20.79 10.35 20.87V20.9H4.3C3.28 20.9 2.46 20.08 2.46 19.06C2.46 18.04 3.28 17.24 4.3 17.24H4.34C4.28 17.03 4.24 16.8 4.24 16.56C4.24 15.68 4.68 14.92 5.34 14.47C5.75 14.17 6.26 14 6.79 14C8.2 14 9.36 15.14 9.36 16.56C9.36 16.66 9.33 16.76 9.32 16.86C9.56 16.78 9.81 16.72 10.07 16.72C11.23 16.72 12.16 17.65 12.16 18.81H12.18Z",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.43 9.92H14.54L16.43 7.05H14.54",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.13 7.79H18.24L20.13 4.93H18.24",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindingSleep);
export default __webpack_public_path__ + "static/media/finding-sleep.16d77e8f42c816cbe0d23021cd404e1a.svg";
export { ForwardRef as ReactComponent };